/*
 * Decorative page graphics. They repeat what the text around them says, so
 * they are hidden from assistive technology, and from small screens in CSS.
 */

const COMMUNITY_ROWS = [30, 78, 126, 174, 222, 270]
const FAIR_TILES = [
    { letter: 'F', y: 36 },
    { letter: 'A', y: 112 },
    { letter: 'I', y: 188 },
    { letter: 'R', y: 264 },
]

/** Communities converging on a shared resource that serves all of FAIR. */
export function ConvergenceArt() {
    return (
        <svg className="art art--band" viewBox="0 0 400 300" aria-hidden="true" focusable="false">
            {COMMUNITY_ROWS.map((y) => (
                <path key={y} className="art__line" d={`M36 ${y}C120 ${y} 120 150 190 150`} />
            ))}
            {FAIR_TILES.map(({ letter, y }) => (
                <path key={letter} className="art__line" d={`M240 150C285 150 285 ${y} 340 ${y}`} />
            ))}
            {COMMUNITY_ROWS.map((y) => (
                <circle key={y} className="art__node" cx="30" cy={y} r="8" />
            ))}
            <circle className="art__halo" cx="215" cy="150" r="30" />
            <circle className="art__hub" cx="215" cy="150" r="17" />
            {FAIR_TILES.map(({ letter, y }) => (
                <g key={letter}>
                    <rect className="art__tile" x="340" y={y - 26} width="52" height="52" rx="4" />
                    <text
                        className="art__letter"
                        x="366"
                        y={y}
                        textAnchor="middle"
                        dominantBaseline="central"
                    >
                        {letter}
                    </text>
                </g>
            ))}
        </svg>
    )
}

/** s: declares the shared resource, o: declares another one, -: a gap. */
const MATRIX_ROWS = ['sssoss', 'soosos', 'ssssss', 'os--so', 'ssos-s']
const CELL_WIDTH = 30
const CELL_HEIGHT = 22
const CELL_GAP = 4
const HIGHLIGHTED_ROW = 2

const cellClass: Record<string, string> = {
    s: 'art__cell--solid',
    o: 'art__cell--tint',
    '-': 'art__cell--gap',
}

/** A miniature of the compact matrix, its most convergent row leading to a hub. */
export function MatrixArt() {
    const rowY = (row: number) => 8 + row * (CELL_HEIGHT + CELL_GAP)
    const hubY = rowY(HIGHLIGHTED_ROW) + CELL_HEIGHT / 2
    return (
        <svg className="art art--page" viewBox="0 0 300 138" aria-hidden="true" focusable="false">
            {MATRIX_ROWS.map((_, row) => (
                <path
                    key={row}
                    className={`art__line${row === HIGHLIGHTED_ROW ? ' art__line--accent' : ''}`}
                    d={`M208 ${rowY(row) + CELL_HEIGHT / 2}C240 ${rowY(row) + CELL_HEIGHT / 2} 240 ${hubY} 272 ${hubY}`}
                />
            ))}
            {MATRIX_ROWS.flatMap((cells, row) =>
                [...cells].map((cell, column) => (
                    <rect
                        key={`${row}-${column}`}
                        className={cellClass[cell]}
                        x={4 + column * (CELL_WIDTH + CELL_GAP)}
                        y={rowY(row)}
                        width={CELL_WIDTH}
                        height={CELL_HEIGHT}
                        rx="2"
                    />
                )),
            )}
            <rect
                className="art__highlight"
                x="1"
                y={rowY(HIGHLIGHTED_ROW) - 3}
                width="207"
                height={CELL_HEIGHT + 6}
                rx="4"
            />
            <circle className="art__hub" cx="282" cy={hubY} r="10" />
        </svg>
    )
}
